import { render, staticRenderFns } from "./attrFrom.vue?vue&type=template&id=6ab1ab26&scoped=true"
import script from "./attrFrom.vue?vue&type=script&lang=js"
export * from "./attrFrom.vue?vue&type=script&lang=js"
import style0 from "./attrFrom.vue?vue&type=style&index=0&id=6ab1ab26&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab1ab26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab1ab26')) {
      api.createRecord('6ab1ab26', component.options)
    } else {
      api.reload('6ab1ab26', component.options)
    }
    module.hot.accept("./attrFrom.vue?vue&type=template&id=6ab1ab26&scoped=true", function () {
      api.rerender('6ab1ab26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsAttrs/attrFrom.vue"
export default component.exports